import _asyncToGenerator from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import _ from 'lodash';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import window from 'global/window';
import PublicEnv from 'shared/utils/public-env';
import { formatName } from 'shared/helpers/users';
import useStores from './use-stores';
import { hideZendeskWidget, openZendeskWidget, hideDecagonWidget, showDecagonWidget, closeDecagonWidget, closeZendeskWidget } from '../helpers/tools';
var widgetKey = 'asdf'; // PublicEnv.zendeskMarketplaceKey;

export default function useConsumerChatWidget() {
  var _useStores = useStores(),
    UI = _useStores.UI,
    User = _useStores.User,
    Cart = _useStores.Cart;
  var flags = useFlags();
  var isDecagonEnabled = flags['growth.ecomm.decagon-chatbot.rollout'];
  var client = useLDClient();
  var _useState = useState(false),
    isReady = _useState[0],
    setIsReady = _useState[1];
  useEffect(function () {
    function waitForLDClient() {
      return _waitForLDClient.apply(this, arguments);
    }
    function _waitForLDClient() {
      _waitForLDClient = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return client.waitUntilReady();
              case 2:
                setIsReady(true);
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _waitForLDClient.apply(this, arguments);
    }
    if (client) {
      waitForLDClient();
    }
  }, [client]);
  useEffect(function () {
    if (!isReady) {
      return;
    }
    // just in case the widget gets swapped out mid-session we want to hide the old one
    // presumably when we hit the flag the other widget isn't being replied to anymore, so
    // this is a better experience than the chat widget staying up but the chat ceasing to work
    // so just close and hide the old one if it's there, if it's not then the functions are no-ops anyway
    if (isDecagonEnabled) {
      closeZendeskWidget();
      hideZendeskWidget();
      return initializeDecagon(UI);
    } else if (widgetKey) {
      closeDecagonWidget();
      hideDecagonWidget();
      return initializeZendesk(UI);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDecagonEnabled, isReady]);
  useEffect(function () {
    if (!isDecagonEnabled || !window.duet) {
      return;
    }
    if (User.exists) {
      window.duet.setUserId(User.id);
      window.duet.setMetadata({
        email: User.email,
        name: User.fullName,
        phone: User.phone
      });
    } else {
      window.duet.setMetadata({
        phone: Cart.guestCustomer.phone,
        name: formatName(Cart.guestCustomer)
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.duet, isDecagonEnabled
  // don't update mid-conversation or else decagon clears the chat history and confuses the end user
  // User.id,
  // User.email,
  // User.fullName,
  // User.phone,
  // Cart.guestCustomer,
  // Cart.guestCustomer ? formatName(Cart.guestCustomer) : null,
  ]);
}
function initializeZendesk(UI) {
  if (!PublicEnv.zendeskMarketplaceKey) {
    return;
  }
  if (UI.isVariant("default") && !_.isFunction(window.zE)) {
    var zendeskInitScript = document.createElement("script");
    zendeskInitScript.id = "ze-snippet";
    zendeskInitScript.src = "https://static.zdassets.com/ekr/snippet.js?key=".concat(PublicEnv.zendeskMarketplaceKey);
    zendeskInitScript.async = true;
    document.body.appendChild(zendeskInitScript);
  }
  openZendeskWidget();
  return function () {
    hideZendeskWidget();
  };
}
function initializeDecagon(UI) {
  if (UI.isVariant("default") && !window.duet) {
    var decagonInitScript = document.createElement("script");
    decagonInitScript.id = "chat-loader";
    decagonInitScript.src = "https://decagon.ai/loaders/dutchie.js";
    decagonInitScript.async = true;
    document.body.appendChild(decagonInitScript);
  }

  // make sure it's not hidden from before
  showDecagonWidget();
  return function () {
    return hideDecagonWidget();
  };
}